
export default {
  async mounted() {
    if (this.$store.state.ui.globe.render) {
      try {
        const { default: main } = await import('@/webgl/main')
        const { snapToPoint, cleanup } = await main(this.$refs.canvas, {
          doesAnimateOnScroll: false,
          onPerformanceFail: ({ cleanup }) => {
            cleanup()
            this.$store.dispatch('ui/setGlobe', { render: false })
          },
        })

        this.cleanup = cleanup
        this.$emit('ready', {
          snapToPoint,
          cleanup,
        })
      } catch (error) {
        this.$bugsnag.notify(error)
      }
    }
  },
}
